import { useState, useCallback } from "react";
import { useSidebarModals } from "./useSidebarModals";

/**
 * useSimplifyModals - Simplify-specific modal state management
 *
 * Extends useSidebarModals with Simplify-specific modals (simplify info, watch).
 */
export function useSimplifyModals() {
  // Base sidebar modal state
  const baseModals = useSidebarModals();

  // Simplify-specific modals
  const [showSimplifyModal, setShowSimplifyModal] = useState(false);
  const [watchGame, setWatchGame] = useState(null);

  // Note: showTransientBanner in Simplify supports type parameter
  const showTransientBanner = useCallback((message, type = "success") => {
    if (type === "success") {
      baseModals.showSuccessBannerMessage(message);
    } else {
      baseModals.showTransientBanner(message);
    }
  }, [baseModals]);

  const resetAddGameData = useCallback(() => {
    baseModals.setAddGameData(baseModals.createInitialAddGameData());
  }, [baseModals]);

  return {
    // Base modals (preview, marketplace, reminder, curate sidebar, banners, add game)
    ...baseModals,
    showTransientBanner,
    resetAddGameData,

    // Simplify-specific
    showSimplifyModal,
    setShowSimplifyModal,
    watchGame,
    setWatchGame,
  };
}
